import { Toast } from 'vant';
import { Ref } from 'vue';
import { BikeBizId, getPlatform, getBikeAdSource } from '~mall/constants/bike';
import nativeMgr from '~mall/common/native/native';
import { reqBuyBikeCard, reqOrderPay } from '~mall/model/apis/bike';
import { goTwoWheelCardPage } from '~mall/common/utils/jumpUrl';
import { getCouponMallUrlNew } from '~mall/model/utils';
import { NetError } from '~mall/common/network/err';

export function useBikePurchase() {
  const handletwBikeBuy = async (
    buying: Ref<boolean>,
    twBike: any,
    router: any,
    channelCodeStrPop?: any,
    bizIdStrPop?: any,
  ) => {
    if (buying.value) {
      return;
    }

    buying.value = true;
    let data: Awaited<ReturnType<typeof reqBuyBikeCard>> = null;

    try {
      const { channelCodeStr, bizIdStr } = router.app.$route.query;

      const bizIdParams = (bizIdStrPop === undefined) ? bizIdStr : bizIdStrPop;
      const channelCodeParams = (channelCodeStrPop === undefined)
        ? channelCodeStr
        : channelCodeStrPop;
      const bizId = parseInt(bizIdParams, 10);
      const channelCode = parseInt(channelCodeParams, 10);
      const cityInfo = await nativeMgr.getCityInfo();
      const {
        cityCode = '', adCode = '', latitude = '', longitude = '',
      } = cityInfo || {};
      const { packageGuid, actualPrice, pendingInfos } = twBike.value;

      data = await reqBuyBikeCard({
        _uuid: window.$$user.userGuid,
        cityCode,
        adCode,
        location: {
          lat: latitude,
          lng: longitude,
        },
        bizContent: {
          businessType: bizId === BikeBizId.BICYCLE ? 1 : 2,
          channelCode,
          totalPrice: actualPrice.finalPrice,
          packageList: [
            {
              packageGuid,
              actualPrice,
              pendingInfos,
              category: 1,
            },
          ],
        },
        packagePlatform: getPlatform(),
        version: (await nativeMgr.getDeviceInfo()).version,
        adSource: getBikeAdSource(),
      });
    } catch (e) {
      console.log('错误', e);
      if (e instanceof Error) {
        Toast((e as NetError).netErrMsg || e.message || '未知错误');
      }
    } finally {
      buying.value = false;
    }

    if (!data) {
      return;
    }

    try {
      await reqOrderPay({
        ...data,
        wechatSignTempId: twBike.value.wechatSignTempId,
        returnUrl: getCouponMallUrlNew(),
        monthlySub: twBike.value.paymentLimit === 1,
      });
      goTwoWheelCardPage();
    } catch (e) {
      if (e instanceof Error) {
        Toast(e.message);
      }
    }
  };

  return {
    handletwBikeBuy,
  };
}
